import { StandardStrapiFields } from '../strapi/strapi'
import UserAudit from './components/audit/user-audit'
import MaterialConsumption from './material-consumption'
import PrintJobExecutor from './print-job-executor'
import PrintQueueEntry from './print-queue-entry'
import Shipment from './shipment'
import User from './user'

export default interface PrintJob extends StandardStrapiFields {
    printerComment?: string // примечание к заданию печати
    machineCounter?: number // счетчик станка
    assigned_by?: User // тот, кто назначил задание на станок
    assignedAt?: string // во сколько назначил
    user_audit?: UserAudit // пользователь, который создал и во сколько
    cancelationReason?: CancelationReasons // причина отмены
    otherCancelationReason?: string // другая причина вручную
    approved_by?: User // кем подтверждена печать
    approvedAt?: string // во сколько подтверждено
    actualFloods?: number // кол-во ручьев фактическое
    material_consumptions?: MaterialConsumption[] // фактический расход материалов
    print_job_executors?: PrintJobExecutor[] // исполнители задания печати
    jobStatus?: JobStatuses // статус задания
    print_queue_entries?: PrintQueueEntry[]
    shipment?: Shipment
}

export enum CancelationReasons {
    Other = 'Другое',
}

export enum JobStatuses {
    Created = 'Создан',
    Planned = 'Добавлен в план', // добавлен в очередь на станок
    Preparing = 'Подготовка к печати', // начали подготавливать штампы и формы
    Prepared = 'Готов к печати',
    Printing = 'Печать',
    Completed = 'Завершен',
    Cancelled = 'Отменен',
}
